import { AxiosInstance } from 'axios'
import { SetUserCurrentOfficeResult } from '@dc-shared-web/hooks/api/user'

export type SetUserCurrentOfficeParams = {
  teamId: number
}

export const setUserCurrentOffice = async (
  apiClient: AxiosInstance,
  teamId: number
): Promise<SetUserCurrentOfficeResult> => {
  const { data } = await apiClient.postForm(
    `/ajax/user/set-current-office/${teamId}`
  )

  return data
}
